export default __webpack_public_path__ + "static/logo-e2661363f1943cb22cf0955ce3d75a8e.svg";